module.exports = __webpack_public_path__ + "media/images/common/kuchi_02-9a6a17a0082bf005813291c3b9bcb7a9.gif";